import PropTypes from 'prop-types';
import React from 'react';
import styles from './StaffStatus.css';

class StaffStatus extends React.Component {
  render() {
    const { slot } = this.props;
    if (slot.employee) {
      if (slot.employee.is_email_confirmed) {
        return <span>Verified</span>;
      }
      return (
        <button
          className={`btn ${styles['btn-resend']}`}
          onClick={this._onClickResend}
        >
          Resend Invitation
        </button>
      );
    }
    return (
      <button className={styles['btn-invite']} onClick={this._onClickInvite}>
        Invite Employee
      </button>
    );
  }

  _onClickResend = e => {
    e.stopPropagation();
    this.props.onClickResendInvitation({ email: this.props.email });
  };

  _onClickInvite = e => {
    e.stopPropagation();
    this.props.onClickInviteStaff({ slot: this.props.slot });
  };
}

StaffStatus.propTypes = {
  email: PropTypes.string,
  slot: PropTypes.object,
  onClickInviteStaff: PropTypes.func,
  onClickResendInvitation: PropTypes.func,
};
export default StaffStatus;
